import React from 'react';
import { format } from 'react-string-format';
import Pusher from 'pusher-js';
import {withRouter} from "../withRouter";

class ManageGameGeneral extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            genres: null,
            categories: null,
            isGenresLoaded: false,
            isCategoriesLoaded: false
        };
    }

    componentDidMount() {
        if (this.props.game.company_id) {
            fetch(process.env.REACT_APP_API_URL + "/publisher/company/" + this.props.game.company_id + "/genres", {
                headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
            })
                .then(res => res.json())
                .then(
                    (result) => {
                        this.setState({
                            isGenresLoaded: true,
                            genres: result
                        });
                    },
                    (error) => {
                        this.setState({
                            isGenresLoaded: true,
                            error
                        });
                    }
                )

            fetch(process.env.REACT_APP_API_URL + "/publisher/company/" + this.props.game.company_id + "/categories", {
                headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
            })
                .then(res => res.json())
                .then(
                    (result) => {
                        this.setState({
                            isCategoriesLoaded: true,
                            categories: result.categories
                        });
                    },
                    (error) => {
                        this.setState({
                            isCategoriesLoaded: true,
                            error
                        });
                    }
                )
        }
    }

    handleSubmit(e) {
        e.preventDefault();

        const body = {
            'name': e.target.name.value,
            'tags': e.target.tags.value.split(','),
            'genre': e.target.genre.value,
            'site': e.target.site.value,
            'is_game_release_enabled': e.target.is_game_release_enabled.checked
        };

        this.setState({
            isCategoriesLoaded: false
        })

        console.log(body);

        fetch(format(process.env.REACT_APP_API_URL + '/publisher/game/{0}', this.props.game.id.toString()), {
            method: "PUT",
            body: JSON.stringify(body),
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        }).then((response) => {
            console.log(response);
            console.log(JSON.stringify(body));
            window.location.reload(false);
        });
    }

    render() {
        const { genres, categories, isCategoriesLoaded, isGenresLoaded } = this.state;

        if (! (isGenresLoaded && isCategoriesLoaded)){
            return <div>Loading...</div>
        } else {
            return (
                <div>
                    <form onSubmit={this.handleSubmit.bind(this)}>
                        <label>Name: </label>
                        <input class="form-control" required type="text" name="name"
                               defaultValue={this.props.game.name}/>
                        <br/>
                        <label>Site: </label>
                        <input class="form-control" required type="url" name="site"
                               defaultValue={this.props.game.site}/>
                        <br/>
                        <label>Tags: </label>
                        <input class="form-control" required type="text" name="tags"
                               defaultValue={this.props.game.tags.join(', ')}/>
                        <small id="tags-help" className="form-text text-muted">Separate tags by comma</small>

                        <br/>
                        <br/>
                        <label>Genre: </label>
                        <select className="form-select" aria-label="Default select example" name="genre">
                            {genres.map(genre =>
                                <option selected={genre === this.props.game.genre} key={genre}
                                        value={genre}>{genre.charAt(0).toUpperCase() + genre.slice(1)}</option>
                            )};
                        </select>
                        <br/>
                        <input className="form-check-input" id="is_game_release_enabled" type="checkbox" name="is_game_release_enabled" defaultChecked={this.props.game.is_game_release_enabled ? this.props.game.is_game_release_enabled  : false} />
                        <label className="form-check-label" htmlFor="is_game_release_enabled">Release enabled</label>
                        <br/>

                        <input class="btn btn-success" required type="submit" value="Save changes"/>
                    </form>
                </div>
            );
        }
    }
}

export default withRouter(ManageGameGeneral);
